import {Logger} from "platform/logger/Logger";
import {AppState} from "core/state/AppState";

export class ReadyState {

    private static _logger: Logger = Logger.Of("ReadyState");
    private static _hasLDBrandProps: boolean;
    private static _hasDepositConfigs: boolean;
    private static _ready: boolean;

    private constructor() {
    }

    public static get ready(): boolean {
        return this._ready;
    }

    public static set hasLDBrandProps(value: boolean) {
        this._hasLDBrandProps = value;
        this.checkAppReady();
    }

    public static set hasDepositConfigs(value: boolean) {
        this._hasDepositConfigs = value;
        this.checkAppReady();
    }

    private static checkAppReady(): void {
        this._logger.debug(`Has LD brand props ${this._hasLDBrandProps}`);
        const appState: AppState = AppState.instance();
        if (!this._ready && this._hasLDBrandProps && this._hasDepositConfigs) {
            this._ready = true;
            document.getElementById("RootElement")?.setAttribute("AppReady", "true");
        }
    }
}
